#import '../../fragments/userNotification.fragment.graphql'

mutation viewAllNotifications {
  markAllAsViewed(input: {}) {
    notifications {
      ...UserNotificationFragment
    }
  }
}
